import { Link } from "react-router-dom";
import { SocialNetworks } from "../../social-networks/social-networks";
import './footer.scss';
import { useTranslation } from "react-i18next";

export function Footer(){
    const {t} = useTranslation()
    function getDate(){
        const currentDate = new Date();
        return currentDate.getFullYear()
    }
    return(
        <footer>
            <div className="footer-container">
                <SocialNetworks/>
                <p><a>www.lestoilesdelajuine.fr</a> <span className="hide-mobile">-</span> {t('footer.all_right_reserved')} - {getDate()}</p>
                <ul className="footer-nav">
                    <li><Link to="legal-notice">{t('footer.legal_notice')}</Link></li>
                    <li><Link to="privacy-policy">{t('footer.privacy_policy')}</Link></li>
                </ul>
            </div>
        </footer>
    )
}